import styles from "@/styles/productReviews/index.module.scss";
import { useRef, useState, useEffect } from "react";
import { useRouter } from "next/router";
import DefaultLayout from "@/components/DefaultLayout";
import BreadCrum from "@/components/global/BreadCrum";
import ShopInfo from "@/components/ShopInfo";
import GoogleADSense from "@/components/GoogleADSense";
import MyTags from "@/components/MyTags";
import Chart from "@/components/productDetail/ProductReviews/components/Chart";
import ReviewDetails from "@/components/reviewDetails";
import GoodsComponentWithDiscountNew from "@/components/GoodsComponentWithDiscountNew";
import { Button, Rate, message, Skeleton } from "antd";
import Image from "next/image";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import productApi from "@/service/modules/productApi";
import SwiperSelf from "@/components/SwiperSelf";
import { SwiperSlide } from "swiper/react";
import useCartActions from '@/utils/addTocartAction'
import Link from "next/link";

export default function ProductReviews() {
  const router = useRouter();

  interface PictureItem {
    thumbnailUrl: string;
    imageHDUrl: string;
    imageORUrl: string;
    fileNameUrl: string;
    isDefault: number;
  }

  interface BreadcrumbItem {
    name: string;
    url: string;
    current: boolean;
  }

  interface ReviewData {
    avgRank: number;
    total: number;
    summary: any;
  }

  interface ProductDetailData {
    name: string;
    productID: number;
    categoryID: number;
    url: string;
    enabled: number;
    discontinued: number;
    price: number;
    promotionPrice: number;
    normalPrice: number;
    promotionTypeID: string | number;
    inStock: number;
    courierID: number;
    freeShipping: number;
    preSales: number;
    preSalesDate: string;
    isDropShipping?: number;
    isEmailOnly: boolean;
    isNew: number | undefined;
    isGroup: number;
    onSale: number;
    reduced: number;
    pictures: PictureItem[];
    firstMagnifierImage?: string;
    newThumbnail: string;
    filename: string;
    promotion: {
      productID: number;
      promotionType: number;
      promotionPrice: number;
      normalPrice: number;
      endDate: string;
      status: number;
      notified: number;
      pointRate: string;
      discountPercent: string;
      ebaySync: number;
    };
    emailOnlyFinished: number;
    breadCrumb: BreadcrumbItem[];
    review: ReviewData | null | undefined;
    currentTime: string;
    warehouseID: number;
    crazyDeal?:
    | {
      hoursLeft: number;
      minutesLeft: number;
      secondsLeft: number;
    }
    | undefined;
  }

  const [productId, setProductId] = useState('');
  const [productDetail, setProductDetail] = useState<ProductDetailData | null>();
  const [reviewInfo, setReviewInfo] = useState<any>({
    reviewCount: 0,
    reviewAvgRank: 0,
    reviewSummary: {
      rating1: 0,
      rating2: 0,
      rating3: 0,
      rating4: 0,
      rating5: 0,
    },
  });

  // 获取产品详情数据
  async function getProductDetail(productId: string | number) {
    try {
      setGoodsInfoLoading(true);
      let res = await productApi.getProductDetail(productId);

      if (res.data && res.data.product) {
        // 处理面包屑
        let breadCrumb = res.data.breadCrumb;
        breadCrumb.forEach((element: any) => {
          element.current = false;
        });
        if (Array.isArray(breadCrumb) && breadCrumb.length > 0) {
          // 获取最后一个元素
          const lastBreadcrumbItem = breadCrumb[breadCrumb.length - 1];

          // 修改最后一个元素（例如修改 `name` 属性）
          const modifiedItem = {
            ...lastBreadcrumbItem,
            name: `${lastBreadcrumbItem.name} Reviews`,
            url: `${lastBreadcrumbItem.url}reviews/`,
            current: true,
          };

          // 将修改后的元素推入数组
          breadCrumb.push(modifiedItem);
        }

        res.data.product.breadCrumb = breadCrumb;
        setProductDetail(res.data.product);
        setGoodsInfoLoading(false);
      }
    } catch (error) {
      setGoodsInfoLoading(false);
      console.log("Next.js Error :", JSON.stringify(error));
    }
  }

  // 获取产品评论
  async function getProductScreen(productID: string | number) {
    try {
      let res = await productApi.getProductScreen(productID)
      if (res.data) {
        const { review, relatedProducts } = res.data
        setReviewInfo({
          reviewCount: review.total,
          reviewAvgRank: review.avgRank,
          reviewSummary: review.summary
        })

        if (relatedProducts && relatedProducts.length > 0) {
          relatedProducts.forEach((element: any) => {
            element.imgUrl = element.filename
            element.productName = element.name
          });
          setRecommendData(relatedProducts || [])
        }
      }
    } catch (error: any) {
      console.log(error.message)
    }
  }

  useEffect(() => {
    if (router.isReady) {
      let id = ''
      const path = window.location.pathname; // 获取当前页面的路径
      const match = path.match(/\/product\/(\d+)\//) //取出 /product/ 后的数字
      if (match && match[1]) id = match[1]; // 提取 productId 并设置状态

      if (typeof id === "string") {
        setProductId(id)
        getProductDetail(id);
        getProductScreen(id);
      }
    }
  }, [router.isReady]);

  useEffect(() => {
    if (productDetail && productDetail.productID) {
      // 赋值
    }
  }, [productDetail]);

  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (index: number) => {
    setActiveTab(index);
  };

  interface ProductItem {
    productID: number;
    name: string;
    url: string;
    imgUrl?: string;

    thumbnail?: string;
    smallThumbnail?: string;
    newThumbnail?: string;
    filename?: string;

    price: number;
    normalPrice: number;

    isGroup: number;
    inStock: number;
    preSales: number;

    freeShipping: number;
    onSale: number;
    reduced: number;
    isNew: number;
    isEmailOnly: any,
    promotionTypeID: number;

    promotion: {
      productID: number;
      promotionType: number;
      promotionPrice: number;
      normalPrice: number;
      endDate: string;
      pointRate: string;
      promotionRate: number;
    };
    review: {
      avgRank: number;
      total: number;
    };

    [key: string]: any;
  }
  // 获取Similar Products数据
  const [recommendData, setRecommendData] = useState<ProductItem[]>([]);

  const { addToCart } = useCartActions();

  const [addCartLoading, setAddCartLoading] = useState(false);
  const [goodsInfoLoading, setGoodsInfoLoading] = useState(true);


  const addToCartCallBack = (response: any) => {
    setAddCartLoading(false);
    if (response != "error") {
      message.success("Add to cart successfully!")
      router.push("/view-cart")

    }
  }
  const addCart = (event: any) => {
    setAddCartLoading(true);
    addToCart(event, { productID: productDetail?.productID || '', qty: 1 }, addToCartCallBack)
  }

  const ProductList = () => {
    const swiper: any = useRef(null);

    return (
      <div className={styles["bottom-goods-list"]}>
        <div className={styles["bottom-goods-list-head"]}>
          <div className={styles["head-title"]}>Similar Products</div>
          <div className={styles["head-page"]}>
            <div className={styles["page-left"]}>
              <LeftOutlined
                className={styles["page-icon"]}
                onClick={() => {
                  swiper.current.slidePrev();
                }}
              />
            </div>
            <div className={styles["page-right"]}>
              <RightOutlined
                className={styles["page-icon"]}
                onClick={() => {
                  swiper.current.slideNext();
                }}
              />
            </div>
          </div>
        </div>
        <div className={styles["goods-list"]}>
          <SwiperSelf
            slidesPerView={5}
            autoplay={false}
            hideArrows={true}
            spaceBetween={10}
            ref={swiper}
          >
            {recommendData.map((item: any) => (
              <SwiperSlide key={item.productID}>
                <GoodsComponentWithDiscountNew {...item} />
              </SwiperSlide>
            ))}
          </SwiperSelf>
        </div>
      </div>
    );
  };

  return (
    <DefaultLayout>
      <div className={styles["product-reviews"]}>
        <div className={styles["main"]}>
          {/* 面包屑 */}
          <div className={styles["bread-box"]}>
            {productDetail?.breadCrumb ? (
              <BreadCrum BreadList={productDetail?.breadCrumb}></BreadCrum>
            ) : null}
          </div>

          {/* 商品介绍 */}
          <div className={styles["content"]}>
            {
              goodsInfoLoading
                ?
                <>
                  <Skeleton active paragraph={{ rows: 5 }} />
                </>
                :
                <div className={styles["content-top"]}>
                  <div className={styles["goods-box"]}>
                    <Link
                      href={`${productDetail?.url}`}
                      legacyBehavior
                    >
                      <a rel="noopener noreferrer" target={'_blank'} className={styles["goodsImg"]}>
                        <Image
                          src={productDetail?.filename || ''}
                          width="216"
                          height="216"
                          alt="goodsImg"
                        />
                      </a>
                    </Link>
                    <div className={styles["goodsInfo"]}>
                      <Link
                        href={`${productDetail?.url}`}
                        legacyBehavior
                      >
                        <a rel="noopener noreferrer" target={'_blank'} className={styles["goodsName"]}>
                          {productDetail?.name}
                        </a>
                      </Link>
                      <div className={styles["goodsPrice"]}>
                        <div className={styles["price"]}>
                          <span style={{ fontSize: 27 }}>$</span>
                          {productDetail?.price}
                        </div>
                        {
                          productDetail?.normalPrice && productDetail?.normalPrice != productDetail?.price
                            ? (
                              <div className={styles["crossPrice"]}>${productDetail?.normalPrice}</div>
                            ) : null
                        }
                      </div>
                      <div className={styles["goodsTag"]}>
                        <MyTags promotionTypeID={productDetail?.promotionTypeID} {...productDetail} />
                      </div>
                      {
                        productDetail?.inStock
                          ?
                          <div className={styles["buyNow"]}>
                            <Button type="primary" loading={addCartLoading} onClick={addCart} style={{ width: '180px', fontWeight: 'bold' }}>Buy Now</Button>
                          </div>
                          :
                          <div className={styles["buyNow"]}>
                            <Button type="primary" href={productDetail?.url} style={{ width: '180px', fontWeight: 'bold' }}>Notify Me</Button>
                          </div>
                      }
                    </div>
                  </div>
                  <div className={styles["goods-reviews"]}>
                    <div className={styles["reviews-title"]}>{reviewInfo.reviewCount} Reviews</div>
                    <div className={styles["reviews-rate"]}>
                      <Rate
                        count={5}
                        value={reviewInfo.reviewAvgRank || 5}
                        className={styles["rate-list"]}
                        allowHalf={false}
                        disabled
                      />
                      <div className={styles["rate-desc"]}>{reviewInfo.reviewAvgRank || 5} overall rating</div>
                    </div>
                    <div className={styles["chart-list"]}>
                      <Chart
                        reviewSummary={reviewInfo.reviewSummary}
                        reviewCount={reviewInfo.reviewCount}
                        usageType="quantity"
                      />
                    </div>
                  </div>
                </div>
            }
            {
              productId ? (
                <ReviewDetails
                  productId={productId}
                  courierID={productDetail?.courierID || 0}
                  pictures={productDetail?.pictures || []}
                  productList={recommendData || []}
                  productUrl={productDetail?.url || ''}
                  reviewCount={reviewInfo.reviewCount}
                  onTabChange={handleTabChange}
                />
              ) : null
            }
          </div>

          {/* Similar Products */}
          {
            activeTab !== 3 ? (
              <ProductList />
            ) : null
          }

          {/* 谷歌广告 */}
          <GoogleADSense />
        </div>
      </div>
    </DefaultLayout>
  );
}
